<div class="bolt-space-bottom-2xl bottom-border">
    <bolt-breadcrumbs class="bolt-space-bottom-md" currentleveltext="Farm flexible deductible" iconlink="{{ accountSummaryUrl }}"></bolt-breadcrumbs>
</div>
<bolt-waiting-indicator *ngIf="!isLoadComplete"></bolt-waiting-indicator>
<main *ngIf="isLoadComplete" id="skip-main-content" role="main">
    <div *ngIf="!hasPackageError; else pageErrorState">
        <h1 class="bolt-heading-xl bolt-heading-vibrantBlue">Farm flexible deductible</h1>
        <h4 class="bolt-heading-sm bolt-space-bottom-lg"><strong>
                {{ insuredName | titlecase }}
            </strong>
            <span aria-hidden="true">| </span>
            <strong>{{ policyNumber }}</strong>
        </h4>
        <bolt-select class="bolt-space-bottom-2xl" width="fit-content" id="farmFlexDeductibleTerm" optionaltext="hide" label="Policy term" [placeholder]="placeholderTermLabel"
            [placeholdervalue]="placeholderTermId" [value]="selectedTermId" (change)="onTermChange($event)">
            <option *ngFor="let term of selectablePolicyTerms" [value]="term.id">{{ term.label }}</option>
        </bolt-select>

        <ng-container *ngIf="!hasPackageError">
            <section class="deductible-card bolt-space-bottom-2xl" aria-labelledby="farm-flex-deductible-information">
                <div class="bolt-row bolt-space-left-3xs">
                    <div class="bolt-col-12 bolt-col-md-4 bolt-space-bottom-md">
                        <div class="bolt-row">
                            <div class="bolt-body-copy-md">
                                <strong>Deductible total</strong>
                                <bolt-contextual-help type="push" heading="Your Flexible amount">
                                    <p>This is
                                        the amount your farm has committed to pay as your
                                        deductible.</p>
                                </bolt-contextual-help>
                            </div>
                        </div>
                        <div class="bolt-row bolt-body-copy-md">{{ deductibleSummary?.deductibleTotal === null ? 'Not available' : (deductibleSummary?.deductibleTotal |
                            currency:'USD':'symbol':'1.2-2') }}</div>
                    </div>
                    <div class="bolt-col-12 bolt-col-md-4 bolt-space-bottom-md">
                        <div class="bolt-row">
                            <div class="bolt-body-copy-md">
                                <strong>Deductible paid</strong>
                                <bolt-contextual-help type="push" heading="What you've paid">
                                    <p>The cumulative total of all
                                        claim amounts applied to the flexible deductible so far in your
                                        term.</p>
                                </bolt-contextual-help>
                            </div>
                        </div>
                        <div class="bolt-row bolt-body-copy-md">{{ deductibleSummary?.deductiblePaid === null ? 'Not available' : (deductibleSummary?.deductiblePaid | currency:'USD':'symbol':'1.2-2')
                            }}</div>
                    </div>
                    <div class="bolt-col-12 bolt-col-md-4 bolt-space-bottom-md">
                        <div class="bolt-row">
                            <div class="bolt-body-copy-md">
                                <strong>Deductible balance</strong>
                                <bolt-contextual-help type="push" heading="Your remaining responsibility">
                                    <p>This is how
                                        much of your deductible you have left to pay before Nationwide starts paying
                                        claims.</p>
                                </bolt-contextual-help>
                            </div>

                        </div>
                        <div class="bolt-row bolt-body-copy-md">{{ deductibleSummary?.deductibleBalance === null ? 'Not available' : (deductibleSummary?.deductibleBalance |
                            currency:'USD':'symbol':'1.2-2') }}</div>
                    </div>
                </div>
                <div class="bolt-row bolt-space-left-3xs">
                    <div class="bolt-col-12 bolt-col-md-4 bottom-row-bottom-space">
                        <div class="bolt-row">
                            <div class="bolt-body-copy-md">
                                <strong>Deductible threshold</strong>
                                <bolt-contextual-help type="push" heading="What counts toward your deductible">
                                    <p>This
                                        is the amount needed to have your costs apply toward your Flexible
                                        deductible.</p>
                                </bolt-contextual-help>
                            </div>
                        </div>
                        <div class="bolt-row bolt-body-copy-md">{{ deductibleSummary?.deductibleThreshold === null ? 'Not available' : (deductibleSummary?.deductibleThreshold |
                            currency:'USD':'symbol':'1.2-2') }}</div>
                    </div>
                    <div class="bolt-col-12 bolt-col-md-4">
                        <div class="bolt-row">
                            <div class="bolt-body-copy-md">
                                <strong>Maintenance deductible</strong>
                                <bolt-contextual-help type="push" heading="What you pay after we take over">
                                    <p>This
                                        is the per-claim deductible that you're responsible for once the flexible deductible
                                        balance reaches zero. This number stays the same for every claim once Nationwide starts paying.</p>
                                </bolt-contextual-help>
                            </div>
                        </div>
                        <div class="bolt-row bolt-body-copy-md">{{ deductibleSummary?.maintenanceDeductible === null ? 'Not available' : (deductibleSummary?.maintenanceDeductible |
                            currency:'USD':'symbol':'1.2-2') }}</div>
                    </div>
                </div>
            </section>

            <section class="claims-section" aria-labelledby="farm-flex-claims-heading" *ngIf="selectedTermClaims.length > 0; else noClaimsState">
                <h2 class="bolt-heading-sm bolt-space-bottom-lg" id="farm-flex-claims-heading">Individual claims</h2>
                <div class="bolt-space-bottom-2xl">
                    <div class="desktop-only bolt-table bolt-table-striped bolt-table-primary bolt-space-bottom-md">
                        <table>
                            <thead>
                                <tr>
                                    <th>Claim</th>
                                    <th>Loss date</th>
                                    <th>Status</th>
                                    <th>Loss location</th>
                                    <th>Type of claim</th>
                                    <th>Amount paid to FFD</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let claim of selectedTermClaims">
                                    <td>{{ claim.claimNumber }}</td>
                                    <td>{{ claim.lossDate }}</td>
                                    <td>{{ claim.status }}</td>
                                    <td class="loss-location-cell">{{ claim.lossLocation }}</td>
                                    <td>{{ claim.typeOfClaim }}</td>
                                    <td>{{ claim.amountPaidToFfd === null ? 'Not available' : (claim.amountPaidToFfd | currency:'USD':'symbol':'1.2-2') }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mobile-only bolt-space-bottom-sm">
                        <div *ngFor="let claim of selectedTermClaims" class="bolt-space-bottom-lg">
                            <section class="claim-card bolt-space-inner-sm" id="claim-information-{{ claim.claimNumber }}" aria-label="Claim details for {{ claim.claimNumber }}">
                                <div class="bolt-space-left-lg bolt-space-right-lg">
                                    <div class="bolt-body-copy-lg"><strong>{{ claim.claimNumber }}</strong></div>
                                    <div class="bolt-body-copy-md"><strong>Status:</strong> {{ claim.status }}</div>
                                    <div class="bolt-body-copy-md"><strong>Loss date:</strong> {{ claim.lossDate }}</div>
                                    <div class="bolt-body-copy-md"><strong>Loss location:</strong> <span class="loss-location-cell">{{ claim.lossLocation }}</span></div>
                                    <div class="bolt-body-copy-md"><strong>Type of claim:</strong> {{ claim.typeOfClaim }}</div>
                                    <div class="bolt-body-copy-md"><strong>Amount paid to FFD:</strong> {{ claim.amountPaidToFfd === null ? 'Not available' : (claim.amountPaidToFfd |
                                        currency:'USD':'symbol':'1.2-2') }}</div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <bolt-pagination #pageNavigator *ngIf="totalClaims > displayLimit" [attr.total]="totalPages" [attr.currentpage]="currentPage">
                        <bolt-page-navigator slot="navigator" spread="5"></bolt-page-navigator>
                    </bolt-pagination>
                </div>
            </section>
        </ng-container>

        <ng-template #noClaimsState>
            <bolt-notification type="info" class="bolt-space-bottom-2xl">
                There are no claims available to view for this policy term.
            </bolt-notification>
        </ng-template>

        <bolt-button-bar>
            <bolt-button slot="cancel" id="farmFlexBackButton" (click)="navigateBack()">Back to all accounts</bolt-button>
        </bolt-button-bar>
    </div>

    <ng-template #pageErrorState>
        <div class="empty-state-card error-state-card">
            <h1 class="bolt-heading-xl bolt-heading-vibrantBlue">Farm flexible deductible</h1>
            <bolt-notification type="error" class="bolt-space-bottom-2xl">
                Something went wrong. We&rsquo;re having trouble completing your request right now. Please give us a call at 1-800-421-3535 so we can help you directly.
            </bolt-notification>
        </div>
    </ng-template>
</main>